// Roblox games grouped by category. Universe IDs are used for API calls.
const GAMES = {
  personal: [
    { placeId: '3093229294', universeId: '1116134862' },
    { placeId: '98592317434563', universeId: '8371728708' },
    { placeId: '5041144419', universeId: '1742264997' },
    { placeId: '92604236', universeId: '75587443' },
    { placeId: '5938036553', universeId: '2132866904' },
    { placeId: '171391948', universeId: '81762198' },
    { placeId: '4375619868', universeId: '1404342734' }
  ],
  sparkle: [
    { universeId: '3616389657' },
    { universeId: '5800392930' },
    { universeId: '5850888103' },
    { universeId: '2189871269' },
    { universeId: '6119785988' },
    { universeId: '5033376017' }
  ]
};

/**
 * Fetches Roblox data via our Vercel API route.
 */
async function fetchRobloxApi(universeIds) {
  const response = await fetch(`/api/roblox?universeIds=${universeIds.join(',')}`);
  if (!response.ok) throw new Error('API request failed');
  return response.json();
}

/**
 * Utility to partition an array into chunks of a specified size.
 */
function chunkArray(array, size) {
  const results = [];
  for (let i = 0; i < array.length; i += size) {
    results.push(array.slice(i, i + size));
  }
  return results;
}

/**
 * Formats numbers into human‑readable abbreviations (e.g. 1.2K, 3.4M).
 */
function formatNum(n) {
  if (n >= 1e9) return (n / 1e9).toFixed(1) + 'B';
  if (n >= 1e6) return (n / 1e6).toFixed(1) + 'M';
  if (n >= 1e3) return (n / 1e3).toFixed(1) + 'K';
  return n.toString();
}

/**
 * Fetch statistics for all configured Roblox universes and update the state.
 */
export async function fetchRobloxData(setTotalVisits, setLivePlayers, setGameStats) {
  const allUniverseIds = [
    ...GAMES.personal.map(g => g.universeId),
    ...GAMES.sparkle.map(g => g.universeId)
  ];

  try {
    const chunks = chunkArray(allUniverseIds, 10);
    let combinedData = [];

    for (const chunk of chunks) {
      const data = await fetchRobloxApi(chunk);
      if (data && data.data) {
        combinedData = combinedData.concat(data.data);
      } else {
        console.warn('Received empty data for chunk', chunk);
      }
    }

    // Aggregate totals
    let totalVisits = 0;
    let totalPlaying = 0;
    const gameStats = {};
    combinedData.forEach(game => {
      totalVisits += game.visits || 0;
      totalPlaying += game.playing || 0;
      gameStats[game.id] = {
        visits: formatNum(game.visits || 0),
        playing: formatNum(game.playing || 0)
      };
    });

    console.log('Roblox data fetched:', { totalVisits, totalPlaying, gameStats });

    // Update state with full numbers (no formatting for Hero stats)
    if (setTotalVisits) setTotalVisits(totalVisits.toLocaleString());
    if (setLivePlayers) setLivePlayers(totalPlaying.toLocaleString());
    if (setGameStats) setGameStats(gameStats);
  } catch (err) {
    console.error('Failed to fetch Roblox data', err);
  }
}
